// src/hooks/useCanvas.js
import { useEffect, useRef } from "react";
import { Canvas } from "fabric";

let instance = null;

export default function useCanvas(canvasId, initial = { w: 100, h: 100 }) {
  const ref = useRef(instance);

  useEffect(() => {
    if (ref.current) return;

    const el = document.getElementById(canvasId);
    if (!el) return;

    const canvas = new Canvas(el, {
      width: initial.w,
      height: initial.h,
      backgroundColor: "#FFFFFF",
      preserveObjectStacking: true,
    });

    instance = canvas;
    ref.current = canvas;
  }, [canvasId]);

  return ref.current;
}
